import styled from 'styled-components'
import { tokens } from '@arvoreeducacao/bonsai-ds'

export const Wrapper = styled.div<{ format: string }>`
  color: ${tokens.colors.green1};
  background: ${tokens.colors.white};
  border-radius: ${({ format }) =>
    format === 'audiobook' ? '0px 0px 8px 8px' : '0px 0px 16px 8px;'};
  transition: all 0.3s;
  font-family: ${tokens.fontFamily.base};
  width: 100%;
  padding: ${tokens.spacing.verticalSmall} ${tokens.spacing.verticalXsmall}
    ${tokens.spacing.verticalSmall};
  @media (max-width: ${tokens.sizes.mdScreen}px) {
    background: transparent;
  }
`
export const BookInfoContent = styled.div`
  color: ${tokens.colors.dark5};
  margin: 2px 5px 7px 1px;
`

export const BookCoverFooter = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: end;
  align-items: center;
  font-family: ${tokens.fontFamily.base};
  width: 100%;
`

export const BookCoverFooterMobile = styled.div`
  display: flex;
  align-items: center;
  font-family: ${tokens.fontFamily.base};
  position: absolute;
  border-radius: ${tokens.radius.circular};
  bottom: 8px;
  right: 8px;
  width: 40px;
  height: 40px;
  background-color: white;

  button {
    right: 4px;
  }
`

export const TagWrapper = styled.div`
  margin-right: 5px;
`
export const TagsContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1;
`

export const Author = styled.p<{ a11yEnabled?: boolean }>`
  font-weight: ${tokens.fontWeights.regular};
  font-size: 12px;
  margin: 0px;
  padding-bottom: 2px;
  color: ${({ a11yEnabled }) =>
    a11yEnabled ? tokens.colors.dark5 : tokens.colors.dark4};
  line-height: 130%;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
`
export const Title = styled.p`
  font-weight: ${tokens.fontWeights.bold};
  font-size: ${tokens.fontSize.small};
  color: ${tokens.colors.dark6};
  padding-bottom: 4px;
  transition: 0.3s;
  margin: 0px;
  width: 100%;
  line-height: 130%;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
`
export const EllipsisIcon = styled.button`
  position: absolute;
  bottom: 5px;
  right: 8px;
  height: 32px;
  width: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border: none;
  background: none;
  border-radius: ${tokens.radius.medium};
  transition: 0.1s;
  &:hover {
    background-color: ${tokens.colors.dark1};
    transition: 0.1s;
  }
  img {
    width: 14px;
    height: 16px;
  }
`
